import { render } from "./GeneralTable.vue?vue&type=template&id=1c3d0dde&scoped=true"
import script from "./GeneralTable.vue?vue&type=script&lang=js"
export * from "./GeneralTable.vue?vue&type=script&lang=js"

import "./GeneralTable.vue?vue&type=style&index=0&id=1c3d0dde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3d0dde"]])

export default __exports__